import { format } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

import { TIMEZONE } from './commonConstants'

/**
 * Converts a date string to the client's local timezone and formats it according to the specified format.
 *
 * @param dateString - The input date as a string (e.g., "2025-07-04T14:02:21+0000").
 * @param dateFormat - The output format string compatible with date-fns (e.g., "yyyy-MM-dd HH:mm:ss").
 * @returns The formatted date string in the client's local timezone.
 *
 * @example
 * formatStringDateToLocal("2025-07-04T14:02:21+0000", "yyyy-MM-dd HH:mm:ss");
 * // "2025-07-04 11:02:21" (depending on the client's timezone)
 */
export const formatStringDateToLocal = (dateString: string, dateFormat: string): string => {
  if (!dateString) {
    return ''
  }
  return format(utcToZonedTime(new Date(dateString), TIMEZONE), dateFormat)
}
